const initialState = {
  bank: null,
  value: null
}

export const ACTION_TYPES = {
  WITHDRAWAL_BANK: 'WITHDRAWAL_BANK',
  WITHDRAWAL_VALUE: 'WITHDRAWAL_VALUE'
}

export const setWithdrawalBank = bank => ({
  type: ACTION_TYPES.WITHDRAWAL_BANK,
  payload: bank
})

export const setWithdrawalValue = value => ({
  type: ACTION_TYPES.WITHDRAWAL_VALUE,
  payload: value
})

const withdrawal = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.WITHDRAWAL_BANK:
      return {
        ...initialState,
        bank: payload
      }
    case ACTION_TYPES.WITHDRAWAL_VALUE:
      return {
        ...state,
        value: payload
      }
    default:
      return state
  }
}

export default withdrawal

